import * as Classes from "../classes/index";
import { StepOneModel, defaultStepOneModel } from "../camp-sign-up/redux/reducers/step-one-reducer";
import { StepTwoModel, defaultStepTwoModel } from "../camp-sign-up/redux/reducers/step-two-reducer";
import { StepThreeModel, defaultStepThreeModel } from "../camp-sign-up/redux/reducers/step-three-reducer";
import { StepFourModel, defaultStepFourModel } from "../camp-sign-up/redux/reducers/step-four-reducer";
import { defaultApiModel } from "../camp-sign-up/redux/reducers/api-reducer";
import { defaultStepCountModel } from "../camp-sign-up/redux/reducers/step-count-reducer";
import { parseBoolean } from "./parser";
import * as _ from 'lodash';
import { IAllergy, IDietaryRestriction, IMedicalCondition, IMedication } from "../classes/index";
import { defaultFormErrorModel } from "../camp-sign-up/redux/reducers/form-error-reducer";

function toStepOneModel(tessObject: Classes.PreviouslyRegisteredStudent): StepOneModel {
    let parsedStepOne: StepOneModel = {} as StepOneModel;

    let interests: Array<string> = new Array<string>();
    if (parseBoolean(tessObject.music_ind)) interests.push("Music");
    if (parseBoolean(tessObject.theatre_ind)) interests.push("Theater");
    if (parseBoolean(tessObject.visual_arts_ind)) interests.push("Visual arts");
    if (parseBoolean(tessObject.dance_ind)) interests.push("Dance");
    if (parseBoolean(tessObject.other_interest_ind)) interests.push("Other");

    parsedStepOne.aboutMyChild = {
        interests: interests.join(","),
        details: tessObject.other_interest_text,
        moreDetails: tessObject.notes
    } as Classes.IAboutMyChild;

    let gender = Classes.Gender.OTHER;

    if (tessObject.sex.toUpperCase() === "M")
        gender = Classes.Gender.M;
    else if (tessObject.sex.toUpperCase() === "F")
        gender = Classes.Gender.F;

    parsedStepOne.basicInformation = {
        birthDate: tessObject.dob,
        camp: "",
        firstName: tessObject.fname,
        lastName: tessObject.lname,
        gender: gender,
        grade: tessObject.grade.toString(),
        nickname: tessObject.nickname,
        payFullAmount: true,
        school: tessObject.school,
        sessionKey: "",
        shirtSize: tessObject.t_shirt_size,
        student_cust_no: tessObject.student_cust_no.toString()
    } as Classes.IBasicInformation;

    let correspondenceIdx = 0;

    if (tessObject.p1_correspond_with && tessObject.p2_correspond_with)
        correspondenceIdx = 2;
    else if (tessObject.p2_correspond_with) {
        correspondenceIdx = 1;
    }

    parsedStepOne.parentInformation = {
        sendCorrespondenceTo: correspondenceIdx.toString(),
        parents: new Array<Classes.IParent>()
    } as Classes.IParentInformation;

    const maxParentCount = 2;
    for (let i = 1; i <= maxParentCount; i++) {
        if (i === 1 || tessObject[`p${i}_street_add`]) {

            parsedStepOne.parentInformation.parents.push({
                address: tessObject[`p${i}_street_add`],
                cellPhone: {
                    number: tessObject[`p${i}_phone_mobile`],
                    isPrimary: tessObject[`p${i}_phone_primary`] === "cell"
                } as Classes.IPhone,
                city: tessObject[`p${i}_city`],
                email: tessObject[`p${i}_email`],
                firstName: tessObject[`p${i}_fname`],
                lastName: tessObject[`p${i}_lname`],
                homePhone: {
                    number: tessObject[`p${i}_phone_home`],
                    isPrimary: tessObject[`p${i}_phone_primary`] === "home"
                } as Classes.IPhone,
                state: tessObject[`p${i}_state`],
                workPhone: {
                    number: tessObject[`p${i}_phone_work`],
                    isPrimary: tessObject[`p${i}_phone_primary`] === "work"
                } as Classes.IPhone,
                zip: tessObject[`p${i}_postal_code`]
            } as Classes.IParent);
        }
    }

    parsedStepOne.siblings = new Array<Classes.ISibling>();

    var siblingCount = _(Object.getOwnPropertyNames(tessObject)).filter((str: string) => str.match("^sib[0-9][0-9]?_fname$")).size();

    for (var i = 1; i <= siblingCount; i++) {
        if (tessObject[`sib${i}_fname`].length > 0) {
            var sibling = {
                birthDate: tessObject[`sib${i}_birthdate`],
                firstName: tessObject[`sib${i}_fname`],
                lastName: tessObject[`sib${i}_lname`],
                key: i - 1
            } as Classes.ISibling;
            parsedStepOne.siblings.push(sibling);
        }
    }

    return parsedStepOne;
}

function toStepTwoModel(tessObject: Classes.PreviouslyRegisteredStudent): StepTwoModel {
    let parsedStepTwo: StepTwoModel = {} as StepTwoModel;

    parsedStepTwo.emergencyContacts = new Array<Classes.IEmergencyContact>();

    const maxEmergencyContactCount = 3;

    for (let i = 1; i <= maxEmergencyContactCount; i++) {

        if (!(`ec${i}_fname` in tessObject)) {
            console.warn("Incorrect object received from backend, missing emergency contact properties");
        }

        let emContact: Classes.IEmergencyContact = {
            firstName: tessObject[`ec${i}_fname`],
            lastName: tessObject[`ec${i}_lname`],
            phone: tessObject[`ec${i}_phone`],
            relationship: tessObject[`ec${i}_relationship`]
        } as Classes.IEmergencyContact;

        parsedStepTwo.emergencyContacts.push(emContact);
    }

    parsedStepTwo.healthCareContacts = {
        dentistName: tessObject.dentist_name,
        dentistPhone: tessObject.dentist_phone,
        physicianName: tessObject.physician_name,
        physicianPhone: tessObject.physician_phone
    } as Classes.IHealthCareContact;

    parsedStepTwo.insuranceInformation = {
        healthPlan: tessObject.health_plan_desc,
        policyHolderName: tessObject.health_plan_name,
        policyNumber: tessObject.health_plan_policy_ID
    } as Classes.IInsuranceInformation;

    parsedStepTwo.pickupAuthorization = new Array<Classes.IPickupAuthorization>();

    const maxPickupPeopleCount = 2;

    for (let i = 1; i <= maxPickupPeopleCount; i++) {
        let puContact: Classes.IPickupAuthorization = {
            firstName: tessObject[`pu${i}_fname`],
            lastName: tessObject[`pu${i}_lname`],
            phone: tessObject[`pu${i}_phone`],
        } as Classes.IPickupAuthorization;

        parsedStepTwo.pickupAuthorization.push(puContact);
    }

    parsedStepTwo.transportationPermission = {
        canTakePublicTransportation: parseBoolean(tessObject.public_transit_ind),
        canWalkHome: parseBoolean(tessObject.walk_bike_ind),
        includeNameInCarpoolList: parseBoolean(tessObject.carpool_ind)
    } as Classes.ITransportationPermission;

    return parsedStepTwo;
}

function toStepThreeModel(tessObject: Classes.PreviouslyRegisteredStudent): StepThreeModel {
    let parsedStepThree = {} as StepThreeModel;

    parsedStepThree.immunizations = parseBoolean(tessObject.immunizations_uptodate_ind);

    // 
    parsedStepThree.specialNeedsSection = {
        selected: parseBoolean(tessObject.special_needs_ind),
        description: tessObject.special_needs_desc
    };

    parsedStepThree.administeringMedication = {
        medications: tessObject.allow_otc_str,
        initials: null,
        authorize: null
    };

    const allergiesList: Array<IAllergy> = [
        {
            type: "Peanuts",
            selected: parseBoolean(tessObject.peanut_allergy_ind),
            description: tessObject.peanut_allergy_desc
        },
        {
            type: "Tree Nuts",
            selected: parseBoolean(tessObject.treenut_allergy_ind),
            description: tessObject.treenut_allergy_desc
        },
        {
            type: "Other Foods",
            selected: parseBoolean(tessObject.food_allergy_ind),
            description: tessObject.treenut_allergy_desc
        },
        {
            type: "Medication",
            selected: parseBoolean(tessObject.meds_allergy_ind),
            description: tessObject.meds_allergy_desc
        },
        {
            type: "Bees",
            selected: parseBoolean(tessObject.bee_allergy_ind),
            description: tessObject.bee_allergy_desc
        },
        {
            type: "Outdoor Allergies / Plants",
            selected: parseBoolean(tessObject.plant_allergy_ind),
            description: tessObject.plant_allergy_desc
        },
        {
            type: "Other",
            selected: parseBoolean(tessObject.other_allergy_ind),
            description: tessObject.other_allergy_desc
        }
    ];

    parsedStepThree.allergySection = {
        allergenFreeLunchGroup: parseBoolean(tessObject.allergen_free_lunch_ind),
        epiPenInformation: {
            canSelfAdminister: parseBoolean(tessObject.epipen_can_self_treat_ind),
            childHasMedication: parseBoolean(tessObject.epipen_has_ind),
            keptWithChild: parseBoolean(tessObject.epipen_storage),
            relevantAllergies: tessObject.epipen_which_allergy_str
        },
        allergies: allergiesList
    };

    parsedStepThree.dietarySection = [
        {
            type: "Gluten Free",
            selected: parseBoolean(tessObject.gluten_free_ind)
        },
        {
            type: "Vegetarian",
            selected: parseBoolean(tessObject.vegetarian_ind)
        },
        {
            type: "Vegan",
            selected: parseBoolean(tessObject.vegan_ind)
        },
        {
            type: "Lactose Intolerant",
            selected: parseBoolean(tessObject.lactose_intol_ind)
        },
        {
            type: "Kosher",
            selected: parseBoolean(tessObject.kosher_ind)
        },
        {
            type: "Can your child eat pizza?",
            selected: parseBoolean(tessObject.pizza_ind)
        }
    ];

    const medicalConditions: Array<IMedicalCondition> = [
        {
            type: "Asthma",
            selected: parseBoolean(tessObject.asthma_ind),
            canSelfAdminister: parseBoolean(tessObject.asthma_can_self_treat),
            childHasMedication: parseBoolean(tessObject.asthma_has_inhaler),
            keptWithChild: parseBoolean(tessObject.asthma_inhaler_storage)
        },
        {
            type: "Diabetes",
            selected: parseBoolean(tessObject.diabetes_ind)
        },
        {
            type: "Epilepsy / Seizures",
            selected: parseBoolean(tessObject.seizures_ind)
        },
        {
            type: "Dizziness/Fainting",
            selected: parseBoolean(tessObject.dizziness_ind),
            description: tessObject.dizziness_desc
        },
        {
            type: "Significant medical or surgery history?",
            selected: parseBoolean(tessObject.med_surg_hist_ind),
            description: tessObject.med_surg_hist_desc
        },
        {
            type: "Headaches",
            selected: parseBoolean(tessObject.headaches_ind),
            description: tessObject.headaches_desc
        },
        {
            type: "Other Medical Info",
            selected: parseBoolean(tessObject.other_med_info_ind),
            description: tessObject.other_med_info_desc
        }
    ];

    parsedStepThree.medicalConditionsSection = {
        badActivities: tessObject.unsafe_activities_desc,
        call: parseBoolean(tessObject.call_ind),
        medicalConditions: medicalConditions
    }

    let i = 0;
    let medications: Array<IMedication> = [];
    while (`m${i}_medication_name` in tessObject && tessObject[`m${i}_medication_name`].length > 0) {
        let med: IMedication = {
            key: i,
            name: tessObject[`m${i}_medication_name`],
            dosage: tessObject[`m${i}_dosage`],
            purpose: tessObject[`m${i}_purpose`]
        };

        medications.push(med);

        ++i;
    }

    parsedStepThree.medicationSection = {
        medications: medications,
        administerAtCamp: tessObject.medications_take_at_camp_str === "null" ? "" : tessObject.medications_take_at_camp_str // This is a hack b/c their administerAtCamp field NEEEDS a character.
    };

    return parsedStepThree;
}

function toStepFourModel(tessObject: Classes.PreviouslyRegisteredStudent): StepFourModel {
    let parsedStepFour: StepFourModel;

    parsedStepFour.emergencyRoomRelease = {
        authorize: parseBoolean(tessObject.auth_hospital_ind),
        initials: tessObject.auth_hospital_initials
    } as Classes.IWaiver;

    parsedStepFour.fieldTripPermission = {
        authorize: parseBoolean(tessObject.auth_fieldtrip_ind),
        initials: tessObject.auth_fieldtrip_initials
    } as Classes.IWaiver;

    parsedStepFour.liability = {
        authorize: parseBoolean(tessObject.auth_liability_ind),
        initials: tessObject.auth_liability_initials
    } as Classes.IWaiver;

    parsedStepFour.mediaRelease = {
        authorize: parseBoolean(tessObject.auth_media_ind),
        initials: tessObject.auth_media_initials
    } as Classes.IWaiver;

    parsedStepFour.wellChild = {
        authorize: parseBoolean(tessObject.auth_wellness_ind),
        initials: tessObject.auth_wellness_initials
    } as Classes.IWaiver;

    return parsedStepFour;
}

function trimObj(obj) {
    if (!Array.isArray(obj) && typeof obj != 'object') return obj;
    return Object.keys(obj).reduce(function (acc, key) {
        acc[key.trim()] = typeof obj[key] == 'string' ? obj[key].trim() : trimObj(obj[key]);
        return acc;
    }, Array.isArray(obj) ? [] : {});
}

export function tessToModel(tessObject: Classes.PreviouslyRegisteredStudent): Classes.AppState {
    tessObject = trimObj(tessObject);

    return {
        apiModel: defaultApiModel,
        stepCountModel: defaultStepCountModel,
        stepOneModel: toStepOneModel(tessObject),
        stepTwoModel: toStepTwoModel(tessObject),
        stepThreeModel: toStepThreeModel(tessObject),
        stepFourModel: defaultStepFourModel,
        formErrorModel: defaultFormErrorModel
    }
}


// WEBPACK FOOTER //
// ./app/helpers/tess-to-model.tsx